import { useMemo } from "react";
import { useGetBrandsQuery } from "../api/BrandsApi";

export const useBrands = (brandSlug?: string) => {
  const {data} = useGetBrandsQuery();

  return useMemo(() => {
    return data
      ?.filter(d => !brandSlug || brandSlug == d.urlSlug)?.map(b => ({
        ...b,
        id: b.id ?? -1
      })) ?? [];
  }, [brandSlug, data]);
};
